export default {
      id: "icon-play-usage",
      viewBox: "0 0 30 38",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }